import { render, staticRenderFns } from "./OvasTeachers.html?vue&type=template&id=e9c4dd36&scoped=true&external"
import script from "./OvasTeachers.vue?vue&type=script&lang=js"
export * from "./OvasTeachers.vue?vue&type=script&lang=js"
import style0 from "./OvasTeachers.scss?vue&type=style&index=0&id=e9c4dd36&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c4dd36",
  null
  
)

export default component.exports